import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { useTranslation } from '../../contexts/TranslationContext';
import { apiService } from '../../services/ApiService';
import { useAddIoTDevice } from '../shared/useAddIoTDevice';
import AddIoTDeviceModal from '../shared/AddIoTDeviceModal';
import { Bdi } from '../shared/BidiIsolate';

export default function AssetConnections({ siteId, poi, canEdit, onViewTickets, onCreateTicket, onChanged }: {
  siteId: string; poi: any; canEdit: boolean; onViewTickets?: (poi: any) => void; onCreateTicket?: (poi: any) => void; onChanged: () => void;
}) {
  const { t } = useTranslation();
  const [devices, setDevices] = useState<any[] | null>(null);
  const [error, setError] = useState(false);
  const [revision, setRevision] = useState(0);
  const flow = useAddIoTDevice({ siteId, onDataChanged: () => { setRevision(v => v + 1); onChanged(); } });
  useEffect(() => {
    let stale = false; setDevices(null); setError(false);
    apiService.get(`/assets/${siteId}/iot-devices`).then(list => {
      if (!stale) setDevices((Array.isArray(list) ? list : []).filter(device => (device.poi_ids || []).some((id: unknown) => String(id) === String(poi.id))));
    }).catch(() => { if (!stale) { setError(true); setDevices([]); } });
    return () => { stale = true; };
  }, [siteId, poi.id, revision]);
  return <>
    <div className="dt-asset-connections">
      {onViewTickets && <button className="dt-btn sm" onClick={() => onViewTickets(poi)}>{t('assetViewTickets')}</button>}
      {canEdit && onCreateTicket && <button className="dt-btn sm" onClick={() => onCreateTicket(poi)}>{t('assetNewTicket')}</button>}
      {canEdit && <button className="dt-btn sm" onClick={() => flow.openForPOI(poi)}>{t('assetAddDevice')}</button>}
    </div>
    <details><summary>{t('assetDevices')}{devices && !error ? ` (${devices.length})` : ''}</summary>
      {error ? <p role="alert">{t('assetDevicesError')}</p> : devices === null ? <p>{t('loading', 'Loading...')}</p> : !devices.length ? <p className="dt-asset-muted">{t('assetNoDevices')}</p> : devices.map(device => <p key={device.id}><Bdi>{device.name}</Bdi> · {device.status}{device.last_ts && <span className="dt-asset-muted"> · <Bdi>{device.last_metric} {device.last_value}</Bdi> · {new Date(device.last_ts).toLocaleString()}</span>}</p>)}
    </details>
    {flow.target && createPortal(<div className="dt-asset-device-layer"><AddIoTDeviceModal target={flow.target} onDismiss={flow.dismiss} /></div>, document.body)}
  </>;
}
